//messages.js
export default {
    department_id: "Department #",
    department_name: "Department Name",
    manager_id: "Manager",
    location_id: "Location",
    description: "Description",
    cost_center: "Cost Center",
    budget: "Budget",
    start_date: "Start Date",
    end_date: "End Date",
    parent_department_id: "Parent Department",
    edit_department: "Edit Department",
    add_department: "Add Department",
    delete_department: "Delete Department",
    departments: "Departments",
    delete_department_confirm: "This action is not reversible!",
};
